import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { AccionesDialog } from '@models/base/identificadores.model';
import { MenuDto } from '@models/seguridad/menu/menuDto.model';
import { TipoMovimientoDto } from '@models/tipos-movimiento/tipoMovimientoDto.model';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { TiposMoviemientoService } from '@services/tipos-movimiento/tipos-movimiento.service';
import { DialogUpdateMenuComponent } from '@views/seguridad/menus/actualizar-menu/dialog-update-menu/dialog-update-menu.component';
import { DialogCreateMenuComponent } from '@views/seguridad/menus/crear-menu/dialog-create-menu/dialog-create-menu.component';
import { DialogDeleteMenuComponent } from '@views/seguridad/menus/eliminar-menu/dialog-delete-menu/dialog-delete-menu.component';
import { DialogViewMenuComponent } from '@views/seguridad/menus/ver-menu/dialog-view-menu/dialog-view-menu.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { DialogUpdateTipoMovimientoComponent } from '../actualizar-tipo-movimiento/dialog-update-tipo-movimiento/dialog-update-tipo-movimiento.component';
import { DialogCreateTipoMovimientoComponent } from '../crear-tipo-movimiento/dialog-create-tipo-movimiento/dialog-create-tipo-movimiento.component';
import { DialogDeleteTipoMovimientoComponent } from '../eliminar-tipo-movimiento/dialog-delete-tipo-movimiento/dialog-delete-tipo-movimiento.component';
import { DialogViewTipoMovimientoComponent } from '../ver-tipo-movimiento/dialog-view-tipo-movimiento/dialog-view-tipo-movimiento.component';

@Component({
  selector: 'app-listar-tipo-movimiento',
  templateUrl: './listar-tipo-movimiento.component.html',
  styleUrls: ['./listar-tipo-movimiento.component.css']
})
export class ListarTipoMovimientoComponent implements OnInit {

  constructor(
    public dialog: MatDialog,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver,
    private tiposMoviemientoService: TiposMoviemientoService
  ) {
    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      this.displayedColumns = result.matches ?
        ['descripcion', 'accion'] :
        ['descripcion', 'resta', 'editable', 'esAnulable', 'tieneComision', 'accion']
    });

  }

  data = false
  dataSource = new MatTableDataSource<TipoMovimientoDto>();
  obj!: undefined
  displayedColumns: string[] = [];

  @ViewChild(MatTable, { static: true }) table!: MatTable<any>;

  private paginator!: MatPaginator;
  private sort!: MatSort;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (this.paginator && this.sort) {
      this.applyFilter(null);
    }
  }
  ngOnInit() {
    this.getAllTiposMovimiento();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  openDialogCreate() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.width = "30%"
    const dialogRef = this.dialog.open(DialogCreateTipoMovimientoComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.event == AccionesDialog.Agregar) {
        this.getAllTiposMovimiento();
      }
    });
  }

  openDialogUpdate(tipoMovimientoDto:TipoMovimientoDto) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.width = "30%"
    dialogConfig.data = tipoMovimientoDto
    const dialogRef = this.dialog.open(DialogUpdateTipoMovimientoComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.event == AccionesDialog.Modificar) {
        this.getAllTiposMovimiento();
      }
    });
  }

  openDialogDelete(tipoMovimientoDto:TipoMovimientoDto) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.width = "30%"
    dialogConfig.data = tipoMovimientoDto
    const dialogRef = this.dialog.open(DialogDeleteTipoMovimientoComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.event == AccionesDialog.Eliminar) {
        this.getAllTiposMovimiento();
      }
    });
  }

  openDialogView(tipoMovimientoDto:TipoMovimientoDto) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.width = "30%"
    dialogConfig.data = tipoMovimientoDto
    const dialogRef = this.dialog.open(DialogViewTipoMovimientoComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.event == AccionesDialog.Ver) {
        this.getAllTiposMovimiento();
      }
    });
  }

  applyFilter(event: any) {
    if (event && event.target && event.target.value !== undefined) {
const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
}
  }

  getAllTiposMovimiento() {
    this.spinner.show()
    this.tiposMoviemientoService.getAll()
      .subscribe(
        data => {
          this.spinner.hide()
          this.dataSource.data = data.sort((a, b) => a.descripcion.localeCompare(b.descripcion));
          this.data = this.dataSource.data.length >= 1 ? true : false
        },
        error => {
          this.spinner.hide()
          this.snackBar.showError(error, "Error");
        }
      )
  }

}
